import React from 'react';

function Footer() {
    return (
        <div className='container-fluid border-top bg-light mt-5'>
            <div className='row my-5 px-5 '>
                <div className='col px-4'>
                    <img src='media/image/logo.svg' style={{ width: "50%" }} />
                    <p> &copy;2010 - 2026, Zerodha Broking Ltd.

                        All rights reserved.</p>
                </div>
                <div className='col footer-link'>
                    <p>Account</p>
                    <a href=''>Open demat account</a><br></br>
                    <a href=''>Minor demat account</a><br></br>
                    <a href=''>NRI demat account</a><br></br>
                    <a href=''>Commodity</a><br></br>
                    <a href=''>Dematerialisation</a><br></br>
                    <a href=''>Fund transfer</a><br></br>
                    <a href=''>MTF</a><br></br>
                    <a href=''>Referral program</a><br></br>
                </div>
                <div className='col footer-link'>
                    <p>Support</p>
                    <a href=''>Contact us</a><br></br>
                    <a href=''>Support portal</a><br></br>
                    <a href=''>How to file a complaint?</a><br></br>
                    <a href=''>Status of your complaints</a><br></br>
                    <a href=''>Bulletin</a><br></br>
                    <a href=''>Circular</a><br></br>
                    <a href=''>Z-Connect blog</a><br></br>
                    <a href=''>Downloads</a><br></br>
                </div>
                <div className='col footer-link'>
                    <p>Company</p>
                    <a href=''>About</a><br></br>
                    <a href=''>Philosophy</a><br></br>
                    <a href=''>Press & media</a><br></br>
                    <a href=''>Careers</a><br></br>
                    <a href=''>Zerodha Cares (CSR)</a><br></br>
                    <a href=''>Zerodha.tech</a><br></br>
                    <a href=''>Open source</a><br></br>
                </div>
                <div className='col footer-link'>
                    <p>
                        Quick links
                    </p>
                    <a href=''>Upcoming IPOs</a><br></br>
                    <a href=''>Brokerage charges</a><br></br>
                    <a href=''>Market holidays</a><br></br>
                    <a href=''>Economic calendar</a><br></br>
                    <a href=''>Calculators</a><br></br>
                    <a href=''>Markets</a><br></br>
                    <a href=''>Sectors</a><br></br>

                </div>
                <div className="row mt-5 text-muted" style={{fontSize:"12px"}}>
                    <p>
                        Zerodha Broking Ltd.: Member of NSE, BSE​ &amp;​ MCX – SEBI
                        Registration no.: INZ000031633 CDSL/NSDL: Depository services through Zerodha Broking Ltd. – SEBI Registration no.: IN-DP-431-2019
                        Registered Address: Zerodha
                        Broking Ltd., #153/154, 4th Cross, Dollars Colony, Opp. Clarence Public
                        School, J.P Nagar 4th Phase, Bengaluru - 560078, Karnataka, India. For
                        any complaints pertaining to securities broking please write to <a href="mailto:complaints@zerodha.com">complaints@zerodha.com</a>, for
                        DP related to <a href="mailto:dp@zerodha.com">dp@zerodha.com</a>. Please
                        ensure you carefully read the Risk Disclosure Document as prescribed by
                        SEBI | ICF
                    </p>
                    <p>
                        Procedure to file a complaint on <a rel="nofollow" href="https://scores.sebi.gov.in/" target="_blank">SEBI SCORES</a>:
                        Register on SCORES portal. Mandatory details for filing complaints on SCORES: Name, PAN, Address, Mobile Number,
                        E-mail ID.
                        Benefits: Effective Communication, Speedy redressal of the grievances
                    </p>
                    <p>
                        <a rel="nofollow" href="https://smartodr.in/" target="_blank">Smart Online Dispute Resolution</a> | <a href="https://zerodha-common.s3.ap-south-1.amazonaws.com/Downloads-and-resources/Smart%20ODR%20info.pdf" target="_blank">Grievances Redressal Mechanism</a>
                    </p>
                    <p>
                        Investments in securities market are subject to market risks; read all the related documents carefully before investing.
                    </p>
                    <p>
                        Attention investors: 1) Stock brokers can accept securities as margins from clients only by way of pledge in the depository system w.e.f September 01, 2020. 2) Update your e-mail and phone number with your stock broker / depository participant and receive OTP directly from depository on your e-mail and/or mobile number to create pledge. 3) Check your securities / MF / bonds in the consolidated account statement issued by NSDL/CDSL every month.
                    </p>
                    <p>
                        India's largest broker based on networth as per NSE. <a rel="nofollow" href="https://enit.nseindia.com/MemDirWeb/brokerDetailPage_Beta?memID=2516&amp;h_MemType=members&amp;memName=ZERODHA%20BROKING%20LIMITED" target="_blank">NSE broker factsheet</a>
                    </p>
                    <p>
                        "Prevent unauthorised transactions in your account. Update your mobile
                        numbers/email IDs with your stock brokers. Receive information of your
                        transactions directly from Exchange on your mobile/email at the end of
                        the day. Issued in the interest of investors. KYC is one time exercise
                        while dealing in securities markets - once KYC is done through a SEBI
                        registered intermediary (broker, DP, Mutual Fund etc.), you need not
                        undergo the same process again when you approach another intermediary."
                        Dear Investor, if you are subscribing to an IPO, there is no need to
                        issue a cheque. Please write the Bank account number and sign the IPO
                        application form to authorize your bank to make payment in case of
                        allotment. In case of non allotment the funds will remain in your bank
                        account. As a business we don't give stock tips, and have not authorized
                        anyone to trade on behalf of others. If you find anyone claiming to be
                        part of Zerodha and offering such services, please <a href="https://support.zerodha.com/category/your-zerodha-account/your-profile/ticket-creation/articles/how-do-i-place-a-complaint-at-zerodha">create
                            a ticket here</a>.
                    </p>
                    <p>
                        *Customers availing insurance advisory services offered by Ditto
                        (Tacterial Consulting Private Limited | IRDAI Registered Corporate Agent (Composite) License No CA0738)
                        will not have access to the exchange investor grievance redressal forum,
                        SEBI SCORES/ODR, or arbitration mechanism for such products.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Footer;